import React from "react";
import { Box, Typography, keyframes } from "@mui/material";

interface JumpingLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

// Define the jump animation with color transition
// Color gets lighter at peak (35%) and brighter when going down/starting
const jump = keyframes`
  0% {
    margin-top: 0;
    background-color: #1976d2;
    transform: scale(1);
  }
  25% {
    margin-top: -50px;
    background-color: #1976d2;
    transform: scale(0.9);
  }
  35% {
    margin-top: -75px;
    background-color: #42a5f5;
    transform: scale(0.85);
  }
  50% {
    margin-top: -50px;
    background-color: #1976d2;
    transform: scale(0.9);
  }
  70% {
    margin-top: 0;
    background-color: #1976d2;
    transform: scale(1);
  }
  85% {
    margin-top: -10px;
    background-color: #1976d2;
    transform: scale(0.95);
  }
  100% {
    margin-top: 0;
    background-color: #1976d2;
    transform: scale(1);
  }
`;

const JumpingLoader: React.FC<JumpingLoaderProps> = ({
  message = "We are almost there...",
  fullScreen = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: fullScreen ? "100vh" : "100%",
        width: fullScreen ? "100vw" : "100%",
        backgroundColor: "transparent",
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "max-content",
          p: 2,
        }}
      >
        {/* Loader Container */}
        <Box
          sx={{
            width: 180,
            height: 80,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          {[0, 1, 2, 3].map((index) => (
            <Box
              key={index}
              sx={{
                width: 15,
                height: 15,
                borderRadius: "50%",
                mx: "15px",
                animation: `${jump} 1.2s ease-in-out infinite`,
                // Apply staggered delays
                animationDelay: `${index * 0.2}s`,
              }}
            />
          ))}
        </Box>

        {/* Caption */}
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            fontFamily: "Arial",
            fontSize: "20px",
            color: "white",
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default JumpingLoader;
